import React from "react";
import {
  Dialog,
  FlatButton,
  RaisedButton,
  TextField,
  Checkbox
} from "material-ui";
import Select from "react-select";
import set from "lodash/set";
import get from "lodash/get";
import Codemirror from "react-codemirror";
import "codemirror/mode/javascript/javascript";

import BaseOverlay from "./overlays/base.jsx";

import config from "../../config";

import Label from "./label.jsx";
import moment from "moment";

class UserEditorModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      user: {},
      values: {}
    };

    this.onRequestClose = this.onRequestClose.bind(this);
    this.onSave = this.onSave.bind(this);
    this.onChangeValue = this.onChangeValue.bind(this);
  }

  getStyles() {
    return {
      container: {
        margin: "15px 0"
      },
      inputContainer: {
        textAlign: "left",
        margin: "0 auto",
        maxWidth: "90%",
        width: 500
      },
      actions: {
        marginTop: 15
      },
      dialogTitle: {
        borderBottom: "none"
      },
      dialogActionsContainer: {
        borderTop: "none"
      }
    };
  }

  onRequestClose() {
    this.props.onCancel();
  }

  onSave() {
    this.props.onSave(this.state.values);
  }

  onChangeValue(id, value) {
    let { values } = this.state;
    set(values, id, value);
    this.setState({ values });
  }

  onFakeEventBucket() {
    this.props.onFakeEventBucket();
  }

  componentDidMount() {
    this.componentWillReceiveProps(this.props);
  }

  componentWillReceiveProps(newProps) {
    let user = newProps.user || { global_config: {} };

    this.setState({
      user,
      values: {
        organization: user.organization,
        fee_percent: user.fee_percent,
        is_demo: user.is_demo,
        currency: user.currency,
        locale: user.locale,
        stripe_account_mode: user.stripe_account_mode,
        stripe_customer_id: user.stripe_customer_id,
        virtual_festival_plan: user.virtual_festival_plan,
        virtual_festival_plan_status: user.virtual_festival_plan_status,
        eventival_config: JSON.stringify(user.eventival_config, null, 2),
        global_config: user.global_config
      }
    });
  }

  render() {
    let styles = this.getStyles(),
      { roles } = this.props;

    return (
      <BaseOverlay
        title={this.props.isNew ? "Create organization" : "Edit organization"}
        titleStyle={styles.dialogTitle}
        actionsContainerStyle={styles.dialogActionsContainer}
        openImmediately={true}
        actions={[
          <FlatButton label="Cancel" onTouchTap={this.onRequestClose} />,
          <FlatButton primary={true} label="Save" onTouchTap={this.onSave} />
        ]}
        modal={true}
        open={true}
        autoDetectWindowHeight={false}
        autoScrollBodyContent={false}
        bodyStyle={{ overflowY: "visible" }}
        onRequestClose={this.onRequestClose}
      >
        <form
          autoComplete="off"
          style={{ margin: "0 auto" }}
          onSubmit={this.onSave}
        >
          <div>
            <TextField
              value={this.state.values.organization}
              floatingLabelText="Organization name"
              floatingLabelFixed={true}
              fullWidth
              onChange={e => this.onChangeValue("organization", e.target.value)}
            />
          </div>
          <div>
            <Label>Currency</Label>
            <Select
              clearable={false}
              value={this.state.values.currency}
              options={config.fee.supported_currencies.map(k => ({
                label: k.toUpperCase(),
                value: k
              }))}
              onChange={e => this.onChangeValue("currency", e ? e.value : "")}
            />
          </div>
          <div>
            <Label>Locale</Label>
            <Select
              clearable={false}
              value={this.state.values.locale}
              options={config.locales.map(k => ({ label: k, value: k }))}
              onChange={e => this.onChangeValue("locale", e ? e.value : "")}
            />
          </div>
          <div>
            <Label>Fee percent</Label>
            <Select
              clearable={false}
              value={this.state.values.fee_percent}
              options={[
                { label: "2%", value: 2 },
                { label: "4.5%", value: 4.5 }
              ]}
              onChange={e =>
                this.onChangeValue("fee_percent", e ? e.value : "")
              }
            />
          </div>
          <div>
            <Label>Mode</Label>
            <Select
              clearable={false}
              value={this.state.values.is_demo ? "demo" : "standard"}
              options={[
                { label: "Standard", value: "standard" },
                { label: "Demo (no charges)", value: "demo" }
              ]}
              onChange={e =>
                this.onChangeValue("is_demo", e && e.value === "demo")
              }
            />
          </div>

          <div>
            <Label>Eventive Virtual</Label>
            {this.state.user.virtual_festival_plan_status === "active" ? (
              <div>
                <div>
                  Eventive Virtual is currently activated and{" "}
                  {this.state.user.virtual_festival_plan_payment_due_at
                    ? `payment is due ${moment(
                        this.state.user.virtual_festival_plan_payment_due_at
                      ).format("LLL")}`
                    : "no payment is due"}
                  .
                </div>
                <Checkbox
                  checked={
                    this.state.values.virtual_festival_plan_status === "expired"
                  }
                  label={
                    "Immediately DEACTIVATE Eventive Virtual subscription and revoke virtual access. This will permanently cancel the subscription and TERMINATE ACCESS IMMEDIATELY."
                  }
                  style={{ marginTop: "0.5em" }}
                  onCheck={(e, checked) =>
                    this.onChangeValue(
                      "virtual_festival_plan_status",
                      checked ? "expired" : "active"
                    )
                  }
                />
              </div>
            ) : (
              <div>
                <div>Not currently enrolled in Eventive Virtual.</div>
                <Checkbox
                  checked={
                    this.state.values.virtual_festival_plan_status === "active"
                  }
                  label={"Enroll in Eventive Virtual"}
                  style={{ marginTop: "0.25em" }}
                  onCheck={(e, checked) =>
                    this.onChangeValue("virtual_festival_plan_status", "active")
                  }
                />
              </div>
            )}
            {this.state.values.virtual_festival_plan_status === "active" ? (
              <Select
                clearable={false}
                style={{ marginTop: "0.5em" }}
                value={this.state.values.virtual_festival_plan}
                options={[
                  {
                    label: "Standard virtual festival billing plan",
                    value: "standard"
                  },
                  {
                    label: "Distributor virtual festival billing plan",
                    value: "distributor"
                  },
                  {
                    label: "Single Film virtual festival billing plan",
                    value: "single_film"
                  }
                ]}
                onChange={e =>
                  this.onChangeValue("virtual_festival_plan", e ? e.value : "")
                }
              />
            ) : null}
          </div>

          <div>
            <Label>Eventival config</Label>
            <Codemirror
              ref={r => r && r.getCodeMirror().setSize(null, 100)}
              value={get(this.state, "values.eventival_config", "")}
              onChange={this.onChangeValue.bind(this, "eventival_config")}
              options={{
                lineWrapping: true,
                lineNumbers: true,
                tabSize: 2,
                indentUnit: 2,
                mode: { name: "javascript", json: true }
              }}
            />
          </div>
          <div>
            <Label>Advanced</Label>
            <Checkbox
              checked={get(
                this.state.values,
                "global_config.facebook_login_disabled"
              )}
              label={'Disable "Login with Facebook" functionality'}
              onCheck={(e, checked) =>
                this.onChangeValue(
                  "global_config.facebook_login_disabled",
                  checked
                )
              }
            />
            <Checkbox
              checked={get(this.state.values, "global_config.cannes_mode")}
              label={"Enable Cannes mode"}
              onCheck={(e, checked) =>
                this.onChangeValue("global_config.cannes_mode", checked)
              }
            />
            <Checkbox
              checked={get(this.state.values, "global_config.gdpr_opt_in")}
              label={"Show GDPR opt-in"}
              onCheck={(e, checked) =>
                this.onChangeValue("global_config.gdpr_opt_in", checked)
              }
            />
            <Checkbox
              checked={get(
                this.state.values,
                "global_config.external_pos_enabled"
              )}
              label={"Enable external POS"}
              onCheck={(e, checked) =>
                this.onChangeValue(
                  "global_config.external_pos_enabled",
                  checked
                )
              }
            />
          </div>
          <TextField
            value={this.state.values.stripe_customer_id}
            floatingLabelText="Set Stripe customer ID (optional)"
            placeholder="(will create new Stripe customer)"
            floatingLabelFixed={true}
            onChange={e =>
              this.onChangeValue("stripe_customer_id", e.target.value)
            }
          />
          {!this.props.isNew ? (
            <div>
              <Label>Generate fake event bucket</Label>
              <RaisedButton
                label="Generate fake event bucket"
                onTouchTap={() =>
                  window.confirm("Are you sure?") &&
                  this.props.onFakeEventBucket()
                }
              />
            </div>
          ) : null}
        </form>
      </BaseOverlay>
    );
  }
}

export default UserEditorModal;



// WEBPACK FOOTER //
// ./src/app/components/partials/user-editor-modal.jsx